export default function googleTranslateLazyFix() {
  let googleTranslateMenuEls = document.querySelectorAll('[data-gt-lazy-src]');
  if (! googleTranslateMenuEls) return;

  googleTranslateMenuEls.forEach(el => {
    let src = el.getAttribute('data-gt-lazy-src');
    if (src) el.setAttribute('src', src);
  });
}
